import { selectorId } from 'app/area/shared/selector-id';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { ExperienceTransferState } from '../types-store';
import { hasChanges } from './utils/has-changes';

export interface ExperienceTransferFormSelectorProps {
  id: number;
  shouldPrompt: boolean;
}

type ExperienceTransferFormSelectors = { [T in keyof ExperienceTransferFormSelectorProps]?:
  (state: ExperienceTransferState, props: DefaultContainerProps) => ExperienceTransferFormSelectorProps[T] };

export const selectors: ExperienceTransferFormSelectors = {
  shouldPrompt: ({ form }) =>
    hasChanges(form?.experienceTransferItem, form?.originalExperienceTransferItem),
  id: (_, { params }) => selectorId(params?.id)
};
